import { render, staticRenderFns } from "./SoliChoice.vue?vue&type=template&id=61058913&scoped=true"
import script from "./SoliChoice.vue?vue&type=script&lang=js"
export * from "./SoliChoice.vue?vue&type=script&lang=js"
import style0 from "./SoliChoice.vue?vue&type=style&index=0&id=61058913&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61058913",
  null
  
)

export default component.exports